import {
  registerStoryblokComponents,
  StoryblokComponentList,
} from "@made-people/grease-storyblok";

import { Footer } from "@made-people/blueprint-footer";
import { Menu, MenuItem } from "@made-people/blueprint-menu";
import { Topbar } from "@made-people/blueprint-topbar";
import { Banner } from "@made-people/blueprint-banner";
import { Table } from "@made-people/blueprint-table";
import { CentraSearchResultsProvider } from "@made-people/grease-centra";
import { GreaseGrowthbookExperimentContainer } from "@made-people/grease-growthbook";
import { ReviewCardSwiper } from "../components/blueprint/swiper/review-card-swiper/default-props";
import { CardBanner } from "../components/blueprint/banner/card-banner/default-props";
import { ProductList } from "@made-people/blueprint-product-list";
import { ProductQuickshop } from "../components/blueprint/product-quickshop/ProductQuickshop";
import { ButtonAsLink } from "@made-people/blueprint-button";
import { Grid } from "@made-people/blueprint-grid";
import { Swiper } from "@made-people/blueprint-swiper";
import { Accordion } from "@made-people/blueprint-accordion";
import { TextBlock } from "@made-people/blueprint-text-block";
import { SwipeableProductList } from "@made-people/blueprint-swipeable-product-list";
import { Search } from "@made-people/blueprint-search";
import {
  AlgoliaSearchResultsProvider,
  AlgoliaRecommendations,
} from "@made-people/grease-algolia";
import { Products } from "../components/blueprint/product-list/products/default-props";
import { LinkShortcuts } from "@made-people/blueprint-link-shortcuts";
import { PageHeader } from "@made-people/blueprint-page-header";
import { LinksHorizontalImages } from "@made-people/blueprint-links-horizontal-images";
import { LinksFluidImages } from "@made-people/blueprint-links-fluid-images";
import { LinksHoverImages } from "@made-people/blueprint-links-hover-images";
import { BlogPostMarkdown } from "@made-people/blueprint-blog-post-markdown";
import { BlogTeaser } from "@made-people/blueprint-blog-teaser";
import { BlogTeaserSlider } from "@made-people/blueprint-blog-teaser-slider";
import { PartnerLogos } from "@made-people/blueprint-partner-logos";
import { ActionCardToronto } from "@made-people/blueprint-action-card";
import { SwipeableLogos } from "@made-people/blueprint-swipeable-logos";
import { SwipeableBlogPosts } from "@made-people/blueprint-swipeable-blog-posts";
import { FeatureGroup } from "@made-people/blueprint-feature-group";
import { ReviewCard } from "@made-people/blueprint-review-card";
import { ImageAndText } from "@made-people/blueprint-image-and-text";
import { AccordionAndText } from "@made-people/blueprint-accordion-and-text";
import { LogosAndText } from "@made-people/blueprint-logos-and-text";
import { TrustpilotReviews } from "../components/features/trustpilot/components/trustpilot-reviews";
import { CheckoutInformationCard } from "../components/global/CheckoutInformationCard";
import { MiniCartSwipeableProductList } from "../components/blueprint/swipeable-product-list/mini-cart-swipeable/default-props";
import { MMUpsellProductList } from "../components/features/upsell/MMUpsellProductList";
import { InretrnWidget } from "../components/features/inretrn/inretrn-widget";
import { SizeGuideCalculator } from "../components/features/size-guide/size-guide-calculator";
import { SizeGuideTableStoryblok } from "../components/features/size-guide/size-guide-table-storyblok";
import { BlogList } from "../components/features/blog/blog-list";
import { OrderTracking } from "../components/features/order-tracking/order-tracking";

/**
 * Register all Storyblok components that are used in the app.
 *
 * The object's key is the component name in Storyblok, and the value
 * is the React component that should be used to render it.
 */
registerStoryblokComponents({
  ActionCardToronto,
  Banner,
  ButtonAsLink,
  LinkShortcuts,
  LinksHorizontalImages,
  LinksFluidImages,
  LinksHoverImages,
  PageHeader,
  BlogTeaser,
  Grid,
  CardBanner,
  Swiper,
  BlogPostMarkdown,
  TextBlock,
  CentraSearchResultsProvider,
  ProductList,
  Products,
  MarketContainer: StoryblokComponentList,
  CountryContainer: StoryblokComponentList,
  LanguageContainer: StoryblokComponentList,
  ContentGroup: StoryblokComponentList,
  AlgoliaSearchProvider: AlgoliaSearchResultsProvider,
  AlgoliaSearchResultsProvider: AlgoliaSearchResultsProvider,
  AlgoliaRecommendations: AlgoliaRecommendations,
  TrustpilotBanner: TrustpilotReviews,
  Topbar,
  Search,
  SwipeableProductList,
  SwipeableLogos,
  SwipeableBlogPosts,
  FeatureGroup,
  ReviewCard,
  ProductQuickshop,
  InformationCard: CheckoutInformationCard,
  ReviewCardSwiper,
  PartnerLogos,
  ImageAndText,
  Footer,
  Accordion,
  BlogTeaserSlider,
  AccordionAndText,
  MainMenu: Menu,
  MenuItem,
  LogosAndText,
  Table,
  SizeGuideTable: SizeGuideTableStoryblok,
  GreaseGrowthbookExperimentContainer,
  MiniCartSwipeableProductList,
  MMUpsellProductList,
  InretrnWidget,
  SizeGuideCalculator,
  BlogList,
  OrderTracking,
});
